import { render, staticRenderFns } from "./topbar_handle.vue?vue&type=template&id=e4888cf0&scoped=true"
import script from "./topbar_handle.vue?vue&type=script&lang=js"
export * from "./topbar_handle.vue?vue&type=script&lang=js"
import style0 from "./topbar_handle.vue?vue&type=style&index=0&id=e4888cf0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4888cf0",
  null
  
)

export default component.exports